import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { Capacitacion } from '@/app/models/interface/capacitacion.model';
import { Curso } from '@/app/models/interface/curso.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class CursosService {
  private readonly url = environment.api + 'cursos/';
  private readonly http = inject(HttpClient);

  create(curso: Partial<Curso>) {
    return this.http.post<CustomResponse<Curso>>(this.url, curso).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<CustomResponse<PaginatorModel<Curso[], HasPagination>>>(this.url, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          return data.result;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<Curso>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }

  registerInitCurso() {
    const url = this.url + 'registerInitCurso';
    return this.http.get<CustomResponse<Capacitacion[]>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return d.map((c) => {
          return {
            ...c,
            competencia: Array.from(
              new Map(
                c.actividadCompetenciaCapacitaciones?.map((cc) => [
                  cc.competenciaId,
                  cc.competencia,
                ]) || [],
              ).values(),
            ),
            actividades: Array.from(
              new Map(
                c.actividadCompetenciaCapacitaciones?.map((cc) => [
                  cc.actividadId,
                  cc.actividad,
                ]) || [],
              ).values(),
            ),
          };
        });
      }),
    );
  }

  update(id: string, data: Partial<Curso>) {
    const url = this.url + id;
    return this.http.put<CustomResponse<Curso>>(url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }

  setFinalizado(referencia: string) {
    const url = this.url + referencia;

    return this.http.patch<CustomResponse<Curso>>(url, {}).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }

  remove(id: string) {
    const url = this.url + id;
    return this.http
      .delete<CustomResponse<Curso>>(url)
      .pipe(catchError((err) => handleError(err)));
  }
}
